import { useAuth } from 'contexts/auth';
import { markLtiCanvasOauthPending, shouldStartCanvasApiOAuth } from 'pages/LTI/ltiApiBridge';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Loading } from 'shell/components';

const LTILaunchPage = () => {
    const { auth } = useAuth();
    const history = useHistory();

    useEffect(() => {
        if (!auth) return;

        if (['instructor', 'ta', 'student'].includes(auth.role)) {
            if (
                shouldStartCanvasApiOAuth({
                    role: auth.role,
                    hasCanvasApiToken: Boolean(localStorage.getItem('access_token')),
                })
            ) {
                markLtiCanvasOauthPending({
                    courseId: auth.course_id,
                    returnPath: '/assignments',
                });
                window.location.href = '/api-launch';
                return;
            }

            history.replace('/assignments');
            return;
        }

        history.replace('/');
    }, [auth, history]);

    return <Loading />;
};

export default LTILaunchPage;
